export default () => {
  const IFRAME_CLASS = 'js-inline-scorm-iframe inline-scorm-iframe';
  const IFRAME_BODY_CLASS = 'inline-scorm';

  if (document.querySelector('body:not(.user-theme)')) {
    return;
  }

  // Find all SCORM activities on the page and attach click handlers to render them inline
  const scormActivities = document.querySelectorAll('li.scorm.modtype_scorm');
  if (scormActivities.length === 0) return;

  scormActivities.forEach((activity) => {
    const scormActivityLink = activity.querySelector(
      'a[href*="/mod/scorm/view.php"].aalink'
    );
    if (!scormActivityLink) return;

    // Attach click handler to the SCORM activity link to render the SCORM content inline
    scormActivityLink.addEventListener('click', (e) => {
      const scormContainer = activity.querySelector('.js-scorm-container');
      if (!scormContainer) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      //renderScormInline(scormContainer, scormActivityLink.href);
    });
    // scormActivityLink.click();

    const scormContainer = activity.querySelector('.js-scorm-container');
    if (scormContainer) {
      renderScormInline(scormContainer, scormActivityLink.href);
    }

    // Make the related sidebar link also render the SCORM content inline when clicked
    const nav = document.querySelector(`nav.courseindex`);
    if (nav) {
      const observer = new MutationObserver(() => {
        const sidebarLink = nav.querySelector(
          `.courseindex-item a[href="${scormActivityLink.href}"]`
        );
        sidebarLink?.addEventListener('click', (e) => {
          e.preventDefault();
          scormActivityLink.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          });
        });
      });

      observer.observe(nav, {
        childList: true,
        subtree: true
      });
    }
  });

  function renderScormInline(container, url) {
    // Create proper URL object from anchor href
    const parsedURL = new URL(url, window.location.origin);

    // Add inpopup parameter
    parsedURL.searchParams.set('inpopup', '1');

    const iframe = document.createElement('iframe');
    iframe.className = IFRAME_CLASS;
    iframe.src = parsedURL.toString();

    iframe.addEventListener('load', () => {
      try {
        const iframeDoc =
          iframe.contentDocument || iframe.contentWindow.document;

        if (iframeDoc && iframeDoc.body) {
          iframeDoc.body.classList.add(IFRAME_BODY_CLASS);
          //console.log('Class injected into iframe body');
        }
      } catch (err) {
        //console.warn('Unable to access iframe (likely cross-origin):', err);
      }
    });

    container.innerHTML = '';
    container.appendChild(iframe);
  }
};
